import { useDispatch } from "react-redux";

import { useMutation } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

export const useDeleteManifest = (id: string) => {
  const dispatch = useDispatch();

  return useMutation<void>({
    mutationKey: ["deleteManifest", { id }],
    mutationFn: () =>
      dispatch(apiThatThrows.deleteAppManifest.action({ params: { id } })),
    throwOnError: false,
  });
};
